import React from 'react';
import PropTypes from 'prop-types';
import {List} from 'immutable';
import UserAvatar from 'components/pure/utils/UserAvatar';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import Button from '@material-ui/core/Button';
import {Link} from 'react-router';
import './MiniAvatarList.styl';
import buildUrl from 'components/dashboard/buildUrl';
import pluralize from 'pluralize';
import {ThemeProvider} from '@components/@theme';
import {lightTheme} from '@components/@theme/lightTheme';
import {HISTORY_ACTIONS} from 'components/StatsPage2.utils';

export default class MiniAvatarList extends React.PureComponent {
  constructor(props) {
    super(props);
    this.avatar = this.avatar.bind(this);
    this.state = {
      expanded: false,
    };
  }

  getScheduledEnd(plan) {
    const effEnd = plan.schedule.getEffectiveEndDate();

    return (
      <div>
        <strong>Original End Date</strong>: {effEnd ? effEnd.format('MM/DD/YYYY') : 'No end date'}
      </div>
    );
  }

  avatar(plan) {
    const {overdue, adminId, managerId, fromPath} = this.props;
    const completedReviews = plan.reviews.filter(r => r.status === 'COMPLETED').size;
    const totalReviews =
      plan.schedule.recurrenceCount && ` out of ${plan.schedule.recurrenceCount}`;
    const pathname = buildUrl({adminId, managerId}) + '/coaching-plans';
    const state = fromPath
      ? {
          pathname: fromPath,
          action: HISTORY_ACTIONS.PUSH,
        }
      : {};
    const skillNames = plan.getSkillNames();
    const tooltip = (
      <div className="admin-dash-tooltip">
        <h3>Coaching Plan</h3>
        <div className="user-avatars">
          <UserAvatar user={plan.coach.info} />
          <UserAvatar user={plan.recipient.info} />
        </div>
        <div>
          <div>
            <strong>Coach:</strong> {plan.coach.info.getFullName()}
          </div>
          <div>
            <strong>Recipient:</strong> {plan.recipient.info.getFullName()}
          </div>
        </div>
        <div className="skills">
          <span>
            <strong>{pluralize('Skill', plan.contentDetails.size)}:</strong> {skillNames}
          </span>
        </div>
        {plan.completed && (
          <div>
            <strong>Ended</strong>: {plan.completedAt.format('MM/DD/YYYY')}
          </div>
        )}
        {overdue && this.getScheduledEnd(plan)}
        <div>
          {completedReviews}
          {totalReviews} {plan.schedule.recurrenceCount > 1 ? 'meetings' : 'meeting'} completed
        </div>
        <ThemeProvider theme={lightTheme}>
          <Button
            className="ev-button"
            component={Link}
            variant="outlined"
            fullWidth
            to={{
              pathname,
              query: {
                repId: plan.recipient.id,
                planId: plan.id,
              },
              state,
            }}>
            View Plan
          </Button>
        </ThemeProvider>
      </div>
    );

    return (
      <GenericTooltip
        key={plan.coach.id + plan.id}
        positionTop
        hoverBehavior
        tooltip={tooltip}
        className="admin-dash-tooltip-wrapper">
        <Link
          to={{
            pathname,
            query: {
              repId: plan.recipient.id,
              planId: plan.id,
            },
            state,
          }}>
          <UserAvatar user={plan.recipient.info} />
        </Link>
      </GenericTooltip>
    );
  }

  render() {
    const {size, plans} = this.props;
    const {expanded} = this.state;

    if (plans.isEmpty()) return <div className="no-plans">N/A</div>;

    const [planList, showMore] = [
      plans.map(this.avatar).take(expanded ? plans.size : size),
      plans.size > size && !expanded && (
        <div className="overflow-avatar" onClick={() => this.setState({expanded: true})}>
          +{plans.size - size}
        </div>
      ),
    ];

    return (
      <div className="mini-avatar-list">
        {planList}
        {showMore}
      </div>
    );
  }
}

MiniAvatarList.propTypes = {
  // number of circles to render; the last of which will handle overflow
  size: PropTypes.number,
  adminId: PropTypes.string,
  managerId: PropTypes.string,
  fromPath: PropTypes.string,
  plans: PropTypes.instanceOf(List), // List<CoachingPlan>
};

MiniAvatarList.defaultProps = {
  size: 4,
};
